<template>
  <div class="footer-content">
    <div class="footer-inner">
      <div class="footer-nav-grid">
        <div class="footer-card nav-card">
          <div v-for="col in navCols" :key="col.title" class="nav-column">
            <div class="title-text">
              <span class="zhu" />
              {{ col.title }}
            </div>
            <div class="nav-list">
              <button
                v-for="(link, idx) in col.list"
                :key="link.name"
                type="button"
                class="footer-link"
                @click="getForce(link)"
              >{{ link.name }}</button>
            </div>
          </div>
        </div>

        <div class="footer-card contact-card">
          <div class="contact-main">
            <div class="title-text">
              <span class="zhu" />
              联系我们
            </div>
            <div class="contact-list">
              <div v-for="row in contacts" :key="row.key" class="contact-row">
                <img :src="getIconPath(row.icon)" alt="" class="item-icon">
                <div class="contact-copy">
                  <span class="contact-label">{{ row.label }}</span>
                  <span class="contact-value">
                    <span v-if="row.person">{{ row.person }} </span>{{ row.value }}
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div class="qr-item">
            <img :src="qrSrc" alt="国数网微信公众号二维码" class="img-pic">
            <div class="qr-title">{{ qr.title || '国数网' }}</div>
            <div class="qr-subtitle">{{ qr.subtitle || '微信公众号' }}</div>
          </div>
        </div>
      </div>

      <div class="footer-center footer-card resource-card">
        <div v-for="(itemCenter, indexCenter) in dataList2" :key="indexCenter" class="source-row">
          <div class="source-title">{{ itemCenter.name }}</div>
          <div class="source-list">
            <span v-for="(itemCenterChild, indexCenterChild) in itemCenter.list" :key="indexCenterChild" class="source-item">
              <a v-if="sourceHref(itemCenterChild)" :href="sourceHref(itemCenterChild)" target="_blank" rel="noreferrer" class="a-div">{{ sourceLabel(itemCenterChild) }}</a>
              <template v-else>{{ sourceLabel(itemCenterChild) }}</template>
            </span>
          </div>
        </div>
      </div>

      <div class="footer-bottom">
        <div>京ICP备2024043678号-2</div>
        <a class="footurl" href="https://www.12377.cn/" target="_blank" rel="noreferrer">网络违法犯罪举报网站</a>
      </div>
    </div>
  </div>
</template>

<script>
import requset from '@/utils/request.js'
import { getDataType } from '@/api/Layout/index.js'

export default {
  name: 'FooterData',
  data() {
    return {
      navCols: [
        {
          title: '高频链接',
          list: [
            { name: '数据地图', path: '/map' },
            { name: '数据交易大厅', path: '/hall' },
            { name: '行业资料', path: '/resources' },
            { name: '行业专家库', path: '/experts' },
            { name: '直播活动', path: '/live' },
          ],
        },
        {
          title: '数据服务',
          list: [
            { name: '数据报告', path: '/resources' },
            { name: '服务报告', path: '/resources' },
            { name: '数据服务商', path: '/providers' },
            { name: '数据交易所', path: '/hall' },
            { name: '数据需求方', path: '/demand' },
          ],
        },
        {
          title: '关于国数网',
          type: 3,
          list: [
            { name: '关于我们', path: '/about#关于我们' },
            { name: '隐私政策', path: '/about#隐私政策' },
            { name: '版权政策', path: '/about#版权政策' },
            { name: '会员服务协议', path: '/about#会员服务协议' },
            { name: '加入我们', path: '/about#加入我们' },
          ],
        },
      ],
      contacts: [
        { key: 'phone', label: '服务电话:', person: '', value: '15010090628', icon: 'hezuo-7 2@2x.png' },
        { key: 'coop', label: '商务合作:', person: '马老师', value: '15010090628', icon: 'hezuo-7 2@2x.png' },
        { key: 'mail', label: '市场邮箱:', person: '', value: 'marketing@shujuzichan.com', icon: 'youxiang-7 2@2x.png' },
        { key: 'addr', label: '办公地址:', person: '', value: '北京市丰台区星火路1号院昌宁大厦2号楼602', icon: 'youxiang1@2x.png' },
      ],
      qr: { url: '', title: '国数网', subtitle: '微信公众号' },
      dataList2: [
        {
          name: '数据来源',
          type: 1,
          list: [
            { label: '商贸流通', url: '' },
            { label: '医疗健康', url: '' },
            { label: '应急管理', url: '' },
            { label: '气象服务', url: '' },
            { label: '城市治理', url: '' },
            { label: '绿色低碳', url: '' },
            { label: '工业制造', url: '' },
            { label: '现代农业', url: '' },
          ],
        },
        {
          name: '友情链接',
          type: 2,
          list: [
            { dictLabel: '教育数据', dictValue: 'http://www.people.com.cn/' },
            { dictLabel: '服装数据', dictValue: 'https://www.baidu.com' },
            { dictLabel: '智能制造', dictValue: 'https://www.baidu.com' },
            { dictLabel: '地铁数据', dictValue: 'https://www.baidu.com' },
            { dictLabel: '房地产数据', dictValue: 'https://www.baidu.com' },
            { dictLabel: '光伏数据', dictValue: 'https://www.douyin.com' },
            { dictLabel: '储能数据', dictValue: 'https://www.baidu.com' },
            { dictLabel: '新闻数据', dictValue: 'https://www.baidu.com' },
            { dictLabel: '水产数据', dictValue: 'https://www.baidu.com' },
          ],
        },
      ],
    }
  },
  computed: {
    qrSrc() {
      const url = (this.qr && this.qr.url) || ''
      if (!url) return require('@/assets/images/u381.jpg')
      if (/^https?:\/\//.test(url) || url.startsWith('/xwzx') || url.startsWith('data:')) return url
      if (url.startsWith('/profile')) return `/xwzx${url}`
      return url
    },
  },
  created() {
    this.loadFooter()
  },
  methods: {
    getIconPath(iconName) {
      return require(`@/assets/images/${iconName}`)
    },
    sourceLabel(item) {
      if (item && typeof item === 'object') return item.label || item.dictLabel || ''
      return item || ''
    },
    sourceHref(item) {
      if (!item || typeof item !== 'object') return ''
      return item.url || item.dictValue || ''
    },
    async loadFooter() {
      try {
        const res = await requset({ url: '/xwzx/ow/footer', method: 'get' })
        const data = res && res.data
        if (data && (data.columns || data.contacts || data.sources)) this.applyFooter(data)
      } catch (error) {
        console.error('Error fetching footer:', error)
      }
      this.getData('sys_friendly_link')
    },
    applyFooter(data) {
      if (Array.isArray(data.columns) && data.columns.length) {
        this.navCols = data.columns.map((col) => ({
          title: col.title,
          list: (col.links || []).map((link) => ({ name: link.name, path: link.path || '' })),
        }))
      }
      if (Array.isArray(data.contacts) && data.contacts.length) {
        const icons = {
          phone: 'hezuo-7 2@2x.png',
          coop: 'hezuo-7 2@2x.png',
          mail: 'youxiang-7 2@2x.png',
          addr: 'youxiang1@2x.png',
        }
        this.contacts = data.contacts.map((row) => ({
          key: row.key,
          label: row.label,
          person: row.person || '',
          value: row.value || '',
          icon: icons[row.key] || 'hezuo-7 2@2x.png',
        }))
      }
      if (Array.isArray(data.sources)) {
        const row = this.dataList2.find((item) => item.type === 1)
        if (row) row.list = data.sources.map((item) => ({ label: item.label || '', url: item.url || '' }))
      }
      if (Array.isArray(data.friends) && data.friends.length) {
        const row = this.dataList2.find((item) => item.type === 2)
        if (row) {
          row.list = data.friends.map((item) => ({ dictLabel: item.label || '', dictValue: item.url || '' }))
          row.fromConfig = true
        }
      }
      if (data.qr) this.qr = { url: data.qr.url || '', title: data.qr.title || '国数网', subtitle: data.qr.subtitle || '微信公众号' }
    },
    async getData(type) {
      const friends = this.dataList2.find((item) => item.type === 2)
      if (friends && friends.fromConfig) return
      try {
        const res = await getDataType(type)
        if (res && res.data && res.data.length > 0 && type === 'sys_friendly_link') {
          this.dataList2.forEach((row) => {
            if (row.type === 2 && !row.fromConfig) row.list = res.data
          })
        }
      } catch (error) {
        console.error('Error fetching data:', error)
      }
    },
    getForce(item) {
      const path = (item && item.path) || ''
      if (!path) return
      if (/^https?:\/\//.test(path)) {
        window.open(path, '_blank')
        return
      }
      // 关于页一律用原生锚点：/about#会员服务协议
      const aboutHash = String(path).match(/^\/about\/(.+)$/)
      if (aboutHash) {
        this.$router.push(`/about#${decodeURIComponent(aboutHash[1])}`).catch(() => false)
        return
      }
      this.$router.push(path).catch(() => false)
    },
  },
}
</script>

<style lang="css" scoped>
.footer-content {
  background-image: url('@/assets/images/编组 64.png');
  background-size: cover;
  background-position: 50% center;
  color: #fff;
  padding: 48px 32px 24px;
  box-sizing: border-box;
  overflow: hidden;
  width: 100%;
}
.footer-inner {
  width: 100%;
  max-width: 1560px;
  margin: 0 auto;
  box-sizing: border-box;
}
.footer-nav-grid {
  display: grid;
  grid-template-columns: minmax(0, 1.65fr) minmax(420px, 1fr);
  align-items: stretch;
  gap: 24px;
}
.contact-card,
.nav-card,
.nav-column,
.resource-card {
  min-width: 0;
}
.footer-card {
  padding: 20px 22px;
  border: 1px solid rgba(255, 255, 255, 0.16);
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.08);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.08);
  box-sizing: border-box;
}
.nav-card {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: clamp(20px, 2vw, 40px);
}
.zhu {
  display: inline-block;
  width: 3px;
  height: 20px;
  border-radius: 2px;
  background: #fff;
  margin-right: 9px;
  flex-shrink: 0;
}
.title-text {
  display: flex;
  align-items: center;
  font-family: AlibabaPuHuiTi_3_85_Bold, sans-serif;
  font-size: 20px;
  color: #fff;
  line-height: 1.5;
  font-weight: 700;
  margin-bottom: 16px;
}
.nav-list {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
}
.footer-link {
  appearance: none;
  border: 0;
  background: transparent;
  padding: 0;
  color: rgba(255, 255, 255, 0.76);
  font-family: inherit;
  font-size: 16px;
  line-height: 1.65;
  cursor: pointer;
  transition: color 0.2s, transform 0.2s;
  text-align: left;
}
.footer-link:hover {
  color: #fff;
  transform: translateX(3px);
}
.contact-card {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 132px;
  gap: 22px;
  align-items: center;
}
.contact-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.contact-row {
  display: grid;
  grid-template-columns: 20px minmax(0, 1fr);
  gap: 9px;
  align-items: start;
}
.item-icon {
  width: 20px;
  height: 20px;
  margin-top: 2px;
  object-fit: contain;
  filter: brightness(0) invert(1);
}
.contact-copy {
  display: grid;
  grid-template-columns: max-content minmax(0, 1fr);
  gap: 8px;
  color: rgba(255, 255, 255, 0.86);
  font-size: 14px;
  line-height: 1.65;
}
.contact-label {
  color: rgba(255, 255, 255, 0.64);
  white-space: nowrap;
}
.contact-value {
  min-width: 0;
  overflow-wrap: anywhere;
  word-break: normal;
  color: rgba(255, 255, 255, 0.86);
}
.qr-item {
  text-align: center;
  min-width: 0;
}
.img-pic {
  display: block;
  width: 112px;
  height: 112px;
  margin: 0 auto 10px;
  max-width: 100%;
  object-fit: cover;
  border: 6px solid rgba(255, 255, 255, 0.96);
  box-sizing: border-box;
}
.qr-title {
  color: #fff;
  font-size: 15px;
  line-height: 1.5;
  font-weight: 700;
}
.qr-subtitle {
  color: rgba(255, 255, 255, 0.62);
  font-size: 13px;
  line-height: 1.5;
}
.footer-center {
  margin-top: 24px;
}
.source-row {
  display: flex;
  align-items: flex-start;
  gap: 22px;
  margin-bottom: 10px;
}
.source-title {
  flex: 0 0 72px;
  color: #fff;
  font-size: 14px;
  font-weight: 700;
  line-height: 1.8;
}
.source-list {
  display: flex;
  flex-wrap: wrap;
  gap: 6px 22px;
  min-width: 0;
}
.a-div,
.source-item {
  font-size: 14px;
  line-height: 1.8;
  text-decoration: none;
  color: rgba(255, 255, 255, 0.64) !important;
}
.a-div:hover {
  color: #fff !important;
}
.footer-bottom {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: 8px 20px;
  padding-top: 18px;
  color: rgba(255, 255, 255, 0.45);
  font-size: 13px;
  line-height: 1.6;
}
.footurl {
  color: rgba(255, 255, 255, 0.45);
  text-decoration: none;
}

@media screen and (max-width: 1200px) {
  .footer-content { padding: 40px 28px 24px; }
  .footer-nav-grid { grid-template-columns: 1fr; gap: 24px; }
}
@media screen and (max-width: 768px) {
  .footer-content {
    padding: 18px 12px 12px;
    background-position: center top;
  }
  .footer-nav-grid {
    grid-template-columns: 1fr;
    gap: 10px;
  }
  .footer-card {
    padding: 12px 12px;
    border-radius: 10px;
  }
  .nav-card {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 8px 10px;
  }
  .nav-column {
    min-width: 0;
  }
  .title-text {
    font-size: 13px;
    margin-bottom: 6px;
    line-height: 1.3;
  }
  .zhu {
    width: 3px;
    height: 12px;
    margin-right: 4px;
  }
  .footer-link {
    font-size: 11px;
    line-height: 1.55;
    padding: 0;
    text-align: left;
  }
  .nav-list {
    gap: 2px;
  }
  .contact-card {
    display: grid;
    grid-template-columns: minmax(0, 1fr) auto;
    gap: 10px;
    align-items: center;
  }
  .contact-main .title-text {
    margin-bottom: 6px;
  }
  .contact-row {
    gap: 6px;
    margin-bottom: 4px;
  }
  .item-icon {
    width: 14px;
    height: 14px;
  }
  .contact-copy {
    grid-template-columns: auto minmax(0, 1fr);
    gap: 4px 6px;
    font-size: 11px;
    line-height: 1.35;
  }
  .contact-label {
    white-space: nowrap;
  }
  .contact-value {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .qr-item {
    justify-self: end;
    text-align: center;
  }
  .img-pic {
    width: 64px;
    height: 64px;
  }
  .qr-title {
    font-size: 11px;
    margin-top: 4px;
  }
  .qr-subtitle {
    font-size: 10px;
  }
  .resource-card {
    padding: 10px 12px;
  }
  .source-row {
    display: block;
    margin-bottom: 8px;
  }
  .source-row:last-child {
    margin-bottom: 0;
  }
  .source-title {
    font-size: 12px;
    margin-bottom: 4px;
  }
  .source-list {
    gap: 2px 10px;
  }
  .source-item,
  .a-div {
    font-size: 11px;
    line-height: 1.45;
  }
  .footer-bottom {
    flex-direction: column;
    font-size: 11px;
    gap: 2px;
    margin-top: 10px;
    padding-top: 8px;
  }
}
</style>
